// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1mJUA","title":"AfterBackImages_title__gmSV0","images":"AfterBackImages_images__3AxHB"};